<script lang="ts">
  import TextInput from '$lib/components/reusable/TextInput.svelte';
  import TextArea from '$components/reusable/TextArea.svelte';
  import { acceleratorProfileSchema } from '$shared/api';
  import type { Infer, SuperForm } from 'sveltekit-superforms/client';

  export let superform: SuperForm<Infer<typeof acceleratorProfileSchema>>;
  const { form, errors, constraints, enhance } = superform;
</script>

<form method="POST" use:enhance class="space-y-2xl">
  <TextInput
    label="Email address"
    placeholder="youremail@gmail.com"
    bind:value={$form.email}
    bind:errors={$errors.email}
    bind:constraints={$constraints.email}
  />
  <TextInput
    label="Telegram username"
    placeholder="your_username"
    bind:value={$form.telegramUsername}
    bind:errors={$errors.telegramUsername}
    bind:constraints={$constraints.telegramUsername}
  />
  <TextArea
    label="Other contact information"
    optional
    maxLength={200}
    description="If there are other ways you'd prefer to be contacted, please list them here."
    placeholder="I'd prefer to be DM'd on Twitter at..."
    bind:value={$form.otherContactInfo}
    bind:errors={$errors.otherContactInfo}
    bind:constraints={$constraints.otherContactInfo}
  />
  <TextArea
    label="Accelerator profile appendix"
    optional
    maxLength={500}
    description="You can use this to share more about your background, interests, or what you're able to help others with."
    placeholder="I'm a big tokenomics nerd, happy to connect with anyone working on..."
    bind:value={$form.profileAppendix}
    bind:errors={$errors.profileAppendix}
    bind:constraints={$constraints.profileAppendix}
  />
</form>
